<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header pb-0">
                <h6>Verifikasi Absensi Mobile</h6>
                <p class="text-xs text-secondary mb-0">
                  Absen mobile yang wajah/lokasinya tidak 100% yakin cocok tetap tercatat, tapi menunggu HR meninjau manual di sini sebelum dianggap sah.
                </p>
              </div>
            </div>
            <div class="col-4">
              <select class="form-select mt-4" v-model="status" @change="get()">
                <option value="Flagged">Menunggu Verifikasi</option>
                <option value="Approved">Sudah Disetujui</option>
                <option value="Rejected">Sudah Ditolak</option>
              </select>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder"></th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Karyawan</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal / Jam</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tipe</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Alasan Ditandai</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jarak Kantor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Skor Wajah</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-sm">
                      <a href="javascript:;" @click="lihatFoto(row.id)">
                        <img v-if="photoUrls[row.id]" :src="photoUrls[row.id]" style="width: 48px; height: 48px; object-fit: cover; border-radius: 8px;">
                        <div v-else class="d-flex align-items-center justify-content-center" style="width: 48px; height: 48px; border-radius: 8px; background-color: #F0F2F5;">
                          <i class="fa fa-camera text-secondary" aria-hidden="true"></i>
                        </div>
                      </a>
                    </td>
                    <td class="align-middle text-sm">
                      <h6 class="mb-0 text-sm">{{ row.nama || row.id_karyawan }}</h6>
                      <span class="text-secondary text-xs">{{ row.jabatan }} &middot; {{ row.unit }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-xs font-weight-bold d-block">{{ moment(row.date).locale('id').format('D MMM YYYY') }}</span>
                      <span class="text-secondary text-xs">{{ row.time ? row.time.substring(0,5) : '-' }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="row.type == 'Masuk' ? 'bg-gradient-success' : 'bg-gradient-danger'">{{ row.type }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span
                        v-for="reason in (row.rejection_reason || '').split(',').filter(r => r)"
                        :key="reason"
                        class="badge badge-sm bg-gradient-warning me-1 mb-1"
                      >{{ reasonLabel(reason) }}</span>
                      <span v-if="!row.rejection_reason" class="text-secondary text-xs">-</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.distance_from_office_meters != null ? Math.round(row.distance_from_office_meters) + ' m' : '-' }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.face_match_score != null ? (row.face_match_score * 100).toFixed(0) + '%' : '-' }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <template v-if="row.status == 'Flagged'">
                        <argon-button color="success" size="xs" class="me-1" @click="approve(row.id)">Approve</argon-button>
                        <argon-button color="danger" size="xs" @click="reject(row.id)">Reject</argon-button>
                      </template>
                      <span v-else class="badge badge-sm" :class="row.status == 'Approved' ? 'bg-gradient-success' : 'bg-gradient-danger'">{{ row.status }}</span>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="8" class="text-center text-sm text-secondary py-4">Tidak ada data.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL LIHAT FOTO ======= -->
  <div class="container">
    <vue-final-modal v-model="formFoto.show" classes="modal-container" content-class="modal-content">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">Foto Selfie Absensi</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFoto.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container text-center">
        <img v-if="formFoto.url" :src="formFoto.url" style="max-width: 100%; border-radius: 8px;">
        <p v-else class="text-secondary text-sm">Memuat foto...</p>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import mobileAttendanceReview from '@/services/mobileAttendanceReview.service';
import akun from '@/services/akun.service';
import moment from 'moment';

const REASON_LABELS = {
  face_mismatch: 'Wajah tidak cocok',
  low_gps_accuracy: 'Akurasi GPS rendah',
  mock_location_detected: 'Lokasi palsu (fake GPS)',
  outside_geofence: 'Di luar area kantor',
  no_office_configured: 'Lokasi kantor belum diatur',
};

export default {
  name: "mobile-attendance-review",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      table: { data: [] },
      status: 'Flagged',
      role: '',
      photoUrls: {},
      formFoto: { show: false, url: null },
    };
  },
  mounted() {
    this.get();
    this.getRole();
  },
  methods: {
    moment,
    reasonLabel(reason) {
      return REASON_LABELS[reason] || reason;
    },
    get() {
      let context = this;
      Api(context, mobileAttendanceReview.index({status: context.status})).onSuccess(function(response) {
        context.table.data = response.data.data;
      }).onError(function(error) {
        if (error.response && error.response.status == 404) {
          context.table.data = [];
        } else {
          context.notify('Gagal memuat data', 'error')
        }
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        context.role = response.data.data[0].role;
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    lihatFoto(id) {
      let context = this;
      context.formFoto.show = true;
      context.formFoto.url  = null;
      Api(context, mobileAttendanceReview.selfie(id)).onSuccess(function(response) {
        const url = URL.createObjectURL(response.data);
        context.formFoto.url = url;
        context.photoUrls = { ...context.photoUrls, [id]: url };
      }).onError(function() {
        context.notify('Gagal memuat foto', 'error')
      })
      .call()
    },
    approve(id) {
      var r = confirm("Setujui absensi ini? Data akan masuk ke Attendance Logs seperti absen biasa.");
      if (!r) return;
      let context = this;
      Api(context, mobileAttendanceReview.approve(id)).onSuccess(function() {
        context.get();
        context.notify('Absensi Disetujui', 'success')
      }).onError(function(error) {
        context.notify(error.response?.data?.message || 'Gagal menyetujui', 'error')
      }).call();
    },
    reject(id) {
      var r = confirm("Tolak absensi ini?");
      if (!r) return;
      let context = this;
      Api(context, mobileAttendanceReview.reject(id)).onSuccess(function() {
        context.get();
        context.notify('Absensi Ditolak', 'success')
      }).onError(function() {
        context.notify('Gagal menolak', 'error')
      }).call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 420px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>
